const agency_drawal = {
    path: 'agency_drawal',
    component: resolve => require(['@/pages/admin/storage_audit/agency_drawal.vue'], resolve),
}

export default agency_drawal